import { useCheckoutUrl } from "@circle-react/components/Paywalls/Checkout/hooks/useCheckoutUrl";

export const useHandleSuccessAuthentication = () => {
  const checkoutUrl = useCheckoutUrl();

  const reloadPage = () => {
    if (checkoutUrl !== window.location.href) {
      window.location.href = checkoutUrl;
    } else {
      window.location.reload();
    }
  };

  return {
    reloadPage,
  };
};
